module.exports = __webpack_public_path__ + "static/media/main_mob.18c171c3.png";